import { createFeature, createReducer, on } from '@ngrx/store';
import { PermissionsActions } from './premissions.actions';
import { PermissionModels } from '@share-models';

export type PermissionsState = PermissionModels.UserPermissionsFeatureState & {
  loaded: boolean;
};

export const initialState: PermissionsState = {
  permissions: [],
  entityIds: [],
  loaded: false,
};

export const permissionsStateReducer = createReducer(
  initialState,
  on(PermissionsActions.resetToInitialState, () => {
    return {
      ...initialState,
    };
  }),
  on(
    PermissionsActions.getUserPermissionsSuccess,
    (state, { entityIds, permissions }) => {
      return {
        ...state,
        entityIds,
        permissions,
        loaded: true,
      };
    },
  ),
  on(PermissionsActions.getUserPermissionsFail, (state) => {
    return {
      ...state,
      loaded: true,
    };
  }),
);

export const permissionsFeature = createFeature({
  name: 'permissions',
  reducer: permissionsStateReducer,
});
